import { getApi } from '../../../api';

export async function rateService(rate) {
  try {
    const response = await getApi().put('bookings/rating', { ...rate }, '');

    return response;
  } catch (e) {
    return { status: e.status };
  }
}
